// Types
interface Store {
  // Add other global state properties here as needed
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

type AppContextTypes = never; // No actions defined yet

interface AppAction {
  type: AppContextTypes;
  payload?: unknown;
}

/**
 * Reducer for the global application context.
 */
export default function appReducer(state: Store, action: AppAction): Store {
  switch (action.type) {
  default: {
    return state; // Return state unchanged if no actions match
  }
  }
}

export type { Store, AppAction, AppContextTypes };
